import { Component } from '@angular/core';
import { UtilsService } from '../services/utils.service';

@Component({
  selector: 'app-facebook-pixel',
  templateUrl: './facebook-pixel.component.html',
})
export class FacebookPixelComponent {
  get isProd(): boolean {
    return UtilsService.isProd();
  }
}
